import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  benefits?: string[];
  isExpandable?: boolean;
  delay?: number;
}
export function ServiceCard({
  icon,
  title,
  description,
  benefits,
  isExpandable = false,
  delay = 0
}: ServiceCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="glass-card rounded-2xl p-6 md:p-8 group hover:border-tech-green/50 transition-all duration-300 relative overflow-hidden" data-id="element-131">
      {/* Hover glow effect */}
      <div className="absolute -inset-0.5 bg-gradient-to-r from-tech-green to-tech-blue rounded-2xl opacity-0 group-hover:opacity-20 blur transition duration-500 z-0" data-id="element-132" />

      <div className="relative z-10" data-id="element-133">
        <div className="w-14 h-14 rounded-xl bg-white/5 flex items-center justify-center text-tech-green mb-6 group-hover:scale-110 group-hover:bg-tech-green/10 transition-all duration-300" data-id="element-134">
          {icon}
        </div>

        <h3 className="text-xl font-bold text-white mb-4 group-hover:text-tech-green transition-colors" data-id="element-135">
          {title}
        </h3>

        <p className="text-slate-300 leading-relaxed mb-6" data-id="element-136">{description}</p>

        {isExpandable ? <div data-id="element-137">
            <button onClick={() => setIsExpanded(!isExpanded)} className="flex items-center gap-2 text-sm font-semibold text-tech-blue hover:text-tech-green transition-colors" data-id="element-138">
              {isExpanded ? 'Show Less' : 'Explore Details'}
              <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-139" />
            </button>

            <AnimatePresence data-id="element-140">
              {isExpanded && benefits && <motion.div initial={{
            height: 0,
            opacity: 0,
            marginTop: 0
          }} animate={{
            height: 'auto',
            opacity: 1,
            marginTop: 24
          }} exit={{
            height: 0,
            opacity: 0,
            marginTop: 0
          }} className="overflow-hidden" data-id="element-141">
                  <div className="pt-4 border-t border-white/10" data-id="element-142">
                    <h4 className="text-sm font-semibold text-white mb-3 uppercase tracking-wider" data-id="element-143">
                      Key Benefits
                    </h4>
                    <ul className="space-y-3" data-id="element-144">
                      {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-3 text-slate-300 text-sm" data-id="element-145">
                          <CheckCircle2 className="w-5 h-5 text-tech-green shrink-0" data-id="element-146" />
                          <span data-id="element-147">{benefit}</span>
                        </li>)}
                    </ul>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div> : <Link to="/services" className="inline-flex items-center text-sm font-semibold text-tech-blue hover:text-tech-green transition-colors" data-id="element-148">
            Learn more &rarr;
          </Link>}
      </div>
    </motion.div>;
}